interface AgencyClinicLike {
  id: string;
  clinic_key?: string | null;
}

export function resolveClinicKeyFromAgencyClinicId(
  agencyClinics: AgencyClinicLike[],
  agencyClinicId: string | null | undefined
): string | null {
  if (!agencyClinicId) return null;

  return (
    agencyClinics.find(clinic => clinic.id === agencyClinicId)?.clinic_key ??
    null
  );
}
